"use strict";

var bodySelector = $('body');
window.ChecksDialog = window.ChecksDialog || {
    leavechecked: false
}

bodySelector.on('change', '#checksTable select.dropdownValue', function (e) {
    e.stopImmediatePropagation();
    var row = $(this).parent().parent();
    if (!row.find('td.checkbox input.checkChecked').is(':checked')) {
        row.find('td.checkbox input.checkChecked').trigger('click');
    }
});

bodySelector.on('focusout keypress', '#checksTable input.textValue', function (e) {
    e.stopImmediatePropagation();
    if (e.type === 'focusout' || e.keyCode === 13) {
        var row = $(this).parent().parent();
        var check = row.find('td.checkbox input.checkChecked');
        var dateValue = $(this).closest('td').children('.dateValue');
        var textValue2 = $(this).closest('td').children('.textValue2');
        //Check if has value
        if (!check.is(':checked')
            && ($(this).val() != null && $(this).val().trim() !== "")) {
            //if it has a date/text2 check it also
            if ((dateValue.length > 0 && dateValue.val() !== null && dateValue.val().trim() !== "")
                || (textValue2.length > 0 && textValue2.val() !== null && textValue2.val().trim() !== "")) {
                check.trigger('click');
            } else if (dateValue.length === 0 && textValue2.length === 0) {
                check.trigger('click');
            }
            //if it's checked and the value is empty, uncheck it
        } else if (check.is(':checked') && ($(this).val() === null || $(this).val().trim() === ""))  {
            check.trigger('click');
        }
    }
});

bodySelector.on('focusout keypress', '#checksTable input.dateValue, #checksTable input.textValue2', function (e) {
    e.stopImmediatePropagation();
    if (e.type === 'focusout' || e.keyCode === 13) {
        var row = $(this).parent().parent();
        var check = row.find('td.checkbox input.checkChecked');
        var textValue = $(this).closest('td').children('.textValue');
        //Check if date/text2 has value
        if (!check.is(':checked')
            && ($(this).val() != null && $(this).val().trim() !== "")) {
            //if it has a text value check it also
            if (textValue.length > 0 && textValue.val() !== null && textValue.val().trim() !== "") {
                check.trigger('click');
            } else if (textValue.length === 0) {
                check.trigger('click');
            }
        //if it's checked and the value is empty, uncheck it
        } else if (check.is(':checked') && ($(this).val() === null || $(this).val().trim() === ""))  {
            check.trigger('click');
        }
    }
});

bodySelector.on('click', '#divPopupConfirmationChecksRemaining #checksTable td.checkbox input.checkChecked', function (e) {
    e.stopImmediatePropagation();
    var forchecked = $(this).parent().find('.checkGUID').val();
    if ($(this).is(':checked')) {

        $('#divSetCheckedBy').find('#forCheckSetBy').val(forchecked);

        window.ChecksDialog.leavechecked = false;

        $('#divSetCheckedBy').dialog("open");

        $('#divSetCheckedBy').find('span.validation').hide();

        $.ajax({
            type: "GET",
            url: '/legacy/System/GetLoggedInUser',
            data: {},
            dataType: 'json',
            async: false,
            success: function (data) {
                if (data.AllOk) {
                    $('#divSetCheckedBy').find('#setCheckedByUser').val(data.Username);
                    $('#divSetCheckedBy').find('#setCheckedByUser').attr('value', data.Username);
                    $('#divSetCheckedBy').find('#setCheckedByUserUID').val(data.UserUID);
                    $('#divSetCheckedBy').find('#setCheckedByUserUID').attr('value', data.UserUID);
                }
            }
        });

    } else {
        $(this).parent().parent().find('td.checkedBy').find('.checkByText').val('');
        $(this).parent().parent().find('td.checkedBy').find('.checkByUID').val(0);        
    }
});